import { driverApi } from '@l2u/web-shared';
import { VENDOR_ACTION_STALE_MS } from './useVendorActionCount.ts';

/**
 * The driver portal's Training, Library and File notes tab badges, from ONE
 * request: GET /api/driver/me/nav-counts (apps/api/src/lib/driverNavCounts.ts
 * holds each definition). The Questionnaire tab has its own action count.
 */
export type DriverNavCounts = { training: number; library: number; file_notes: number };

/**
 * Not under the ['driver'] or ['driver-me'] prefixes, for the same reason the
 * company key avoids ['me']: the pages that can move a count (a passed
 * training module, an opened document, an opened file note) invalidate this
 * key themselves.
 */
export const DRIVER_NAV_COUNTS_KEY = ['driver-nav-counts'] as const;

export function driverNavCountsQueryOptions() {
  return {
    queryKey: DRIVER_NAV_COUNTS_KEY,
    queryFn: ({ signal }: { signal: AbortSignal }) =>
      driverApi.get<{ counts: DriverNavCounts }>('/api/driver/me/nav-counts', { signal }),
    staleTime: VENDOR_ACTION_STALE_MS,
  };
}
